export const applyTransform = (
  el: HTMLElement,
  x: number,
  y: number,
  rotate: number
) => {
  el.style.transform = `translate(${x}px, ${y}px) rotate(${rotate}deg)`;
};
